var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C10.4812 2.75 9.25 3.98122 9.25 5.5C9.25 7.01878 10.4812 8.25 12 8.25C13.5188 8.25 14.75 7.01878 14.75 5.5C14.75 3.98122 13.5188 2.75 12 2.75ZM7.75 5.5C7.75 3.15279 9.65279 1.25 12 1.25C14.3472 1.25 16.25 3.15279 16.25 5.5C16.25 7.84721 14.3472 9.75 12 9.75C9.65279 9.75 7.75 7.84721 7.75 5.5Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13.25C6.35818 13.25 2.75 16.5765 2.75 20.5C2.75 20.9142 2.41421 21.25 2 21.25C1.58579 21.25 1.25 20.9142 1.25 20.5C1.25 15.5869 5.70072 11.75 11 11.75C11.4142 11.75 11.75 12.0858 11.75 12.5C11.75 12.9142 11.4142 13.25 11 13.25Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9697 13.4697C18.2626 13.1768 18.7374 13.1768 19.0303 13.4697L21.0303 15.4697C21.3232 15.7626 21.3232 16.2374 21.0303 16.5303L16.0303 21.5303C15.8897 21.671 15.6989 21.75 15.5 21.75H13.5C13.0858 21.75 12.75 21.4142 12.75 21V19C12.75 18.8011 12.829 18.6103 12.9697 18.4697L17.9697 13.4697ZM14.25 19.3107V20.25H15.1893L19.4393 16L18.5 15.0607L14.25 19.3107Z",
    fill: "#1C1B1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0198589d1bc221fd3bf30d37b6354b76.svg";
export { ForwardRef as ReactComponent };